<template>
  <div class="template info-con" @click="hideMore">
    <div class="tmp-title nav-title">
      <div class="tt-left">
        <h2>我的设计</h2>
      </div>
      <div class="tt-right" v-if="loginInfo.current_team_role !== 4">
        <el-button type="primary" @click="newFolder">新建文件夹</el-button>
        <!-- 成员不允许使用上传新增模板 -->
        <el-button
          type="primary"
          @click="uploadPsdOpen"
        >
          上传模板
        </el-button>
      </div>
    </div>
    <div class="tmp-con">
      <ActionBread :breadList="breadList" />
      <div class="template-list">
        <ul class="folder-ul">
          <template v-for="item in templateInfo.team_user_design_directories">
            <ActionFolder :item="item" :key="item.id"></ActionFolder>
          </template>
        </ul>
        <ul
          class="flex-image-folder--box"
          v-if="templateInfo && templateInfo.team_user_design"
        >
          <template v-for="item in templateInfo.team_user_design.data">
            <ActionImage
              :key="item.id"
              :item="item"
              :status="true"
              :type="'template'"
              :DesignworkbenchType="'design'"
            ></ActionImage>
          </template>
        </ul>
        <Pagination
          v-if="Pagination.total > Pagination.page_size"
          @handleCurrentChange="handleCurrentChange"
          :Pagination="Pagination"
        />
      </div>
    </div>

    <RenameDialog
      ref="renameDialog"
      :title="moreInfo && moreInfo.id ? '重命名' : '新建文件夹'"
      @submit="editFolder"
    />
    <MoveFolder @submit="moveSubmit" ref="move" />

    <RemoveDialog
      :title="
        moreInfo && Object.keys(moreInfo).includes('cover_url')
          ? '是否确认删除该素材'
          : '是否确认删除该文件夹'
      "
      @remove="removeFolder"
    />

    <!--上传psd弹出框-->
    <psd
      :teamid="loginInfo && loginInfo.current_team_id"
      :dirid="dir_id"
      :source="'space'"
    />
    <!--团队过期弹出框-->
    <expireTeamDialog />
    <teamNull :imgtext="'暂无数据'" v-if="noContent" />
  </div>
</template>

<script>
import { Space } from "@/config/axios/new_api";
import psd from "./psd.vue";
import Index from "@/config/mixin/index.js";
import teamNull from "@/components/common/teamNull.vue";
import ActionFolder from "@/components/actionContent/folder";
import ActionImage from "@/components/actionContent/image";
import RenameDialog from "@/components/dialog/renameDialog.vue";
import ActionBread from "@/components/actionContent/bread";
import MoveFolder from "@/components/dialog/moveFolder.vue";
import RemoveDialog from "@/components/dialog/removeDialog.vue";
export default {
  components: {
    psd,
    teamNull,
    ActionBread,
    ActionFolder,
    ActionImage,
    RenameDialog,
    MoveFolder,
    RemoveDialog,
  },
  mixins: [Index],
  data() {
    return {
      breadList: [],
      templateInfo: {},
      moreInfo: null,
      moreStatus: false,
      renameStatus: false,
      moveDialogStatus: false,
      removeDialogStatus: false,
      renameInput: "",
      dir_id: 0,
      props: {
        label: "name",
        children: "zones",
        isLeaf: "is_empty",
      },
      Pagination: {
        total: 0,
        page: 1,
        page_size: 25,
      },
      folderTree: {},
      uploadPsdStatus: false,
      noContent: false,
    };
  },
  watch: {
    renameInput: function (newVal) {
      this.renameInput = newVal.replace(/\s*/g, "");
    },
  },
  computed: {
    teamList() {
      return this.$store.getters.teamList; // 后期直接使用domani
    },
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData(
      data = {
        dir_id: this.dir_id,
        page_size: this.Pagination.page_size,
        page: this.Pagination.page,
      }
    ) {
      Space.myspaces(data).then((res) => {
        if (res.data.user_id) {
          this.templateInfo = res.data;
          let pagination = res.data.team_user_design.pagination
          this.Pagination.total = pagination.total;
          let design = this.templateInfo.team_user_design.data;
          //  如果没有任何内容
          if (
            !res.data.team_user_design_directories &&
            pagination.total === 0
          ) {
            this.noContent = true;
          } else {
            this.noContent = false;
            if (pagination.current_page > 1 && design.length == 0) {
              //请求上一页
              this.getData({
                dir_id: this.dir_id,
                per_page: this.Pagination.page_size,
                page: pagination.current_page - 1,
              });
            }
          }
        }
      });
    },
    psdClose() {
      this.uploadPsdStatus = false;
    },
    renameClick() {
      let res = this.expireHandle();
      if(res){
        this.renameStatus = true;
        this.moreStatus = false;
      }
    },
    moreShow(item, type) {
      this.moreInfo = item;
      this.renameInput = item.name;
      this.moreStatus = !this.moreStatus;
      this.moretype = type;
    },
    hideMore() {
      // this.moreInfo = null;
      this.moreStatus = false;
    },
    open() {},
    editFolder() {
      // 修改文件夹名称  新建文件夹
      let rename = this.$refs.renameDialog.renameObj.renameInput;
      if (this.moreInfo && this.moreInfo.team_id) {
        if (Object.keys(this.moreInfo).includes("cover_url")) {
          // 存在图片代表是psd格式  修改图片信息
          if (!rename) {
            this.$message.error("请输入模板名称");
            return;
          }
          Space.rename(
            {
              team_user_design_id: this.moreInfo.id,
              rename,
              team_id: this.moreInfo.team_id,
            }
          ).then((res) => {
            if (res.status === 1) {
              this.$message.success("修改成功");
              this.moreInfo = null;
              this.renameInput = "";
              this.renameStatus = false;
              this.getData();
            }
          });
        } else {
          // 存在图片代表是psd格式  修改图片信息
          if (!rename) {
            this.$message.error("请输入文件夹名称");
            return;
          }
          // 修改文件夹信息
          Space.renameDir(
            {
              team_id: this.moreInfo.team_id,
              dir_name: rename,
              dir_id: this.moreInfo.id,
            }
          ).then((res) => {
            if (res.status === 1) {
              this.$message.success("修改成功");
              this.moreInfo = null;
              this.renameInput = "";
              this.renameStatus = false;
              this.getData();
            }
          });
        }
      } else {
        // const fromData = new FormData();
        // fromData.append("team_id", this.teamList[0].id);
        // fromData.append("dir_name", this.renameInput);
        // fromData.append("dir_id", this.dir_id);
        // const config = {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //   },
        // };
        // 存在图片代表是psd格式  修改图片信息
        if (!rename) {
          this.$message.error("请输入文件夹名称");
          return;
        }
        Space.createDir(
          {
            team_id: this.loginInfo.current_team_id,
            dir_name: rename,
            dir_id: this.dir_id,
          }
        ).then((res) => {
          if (res.status === 1) {
            this.$message.success("新增成功");
            this.moreInfo = null;
            this.renameInput = "";
            this.renameStatus = false;

            this.getData();
          }
        });
      }
    },
    newFolder() {
      let res = this.expireHandle();

      if (res) {
        this.renameStatus = true;
        this.renameInput = "";
        this.moreInfo = null;
      }
    },
    moveTemp() {
      // 点击移动按钮
      let res = this.expireHandle();
      if(res){
        this.moveDialogStatus = true;
        this.$nextTick(()=>{
            let node = this.$refs.move.$refs.tree.getNode(0)
            node.loaded = false
            node.expand()
        })
      }
    },
    createNewFile(item) {
      let name = item.name;
      let suffix = name.split('_副本').length > 1 ?
      			(!Object.is(parseInt(name.split('_副本')[1]), NaN) ? parseInt(name.split('_副本')[1]) + 1 : 1) : 1;
      let data = {
        name: `${name.split('_副本')[0]}_副本${suffix}`.substring(0,20),
        team_user_design_id: item.id
      };
       Space.createNewFile(data).then(res => {
          this.getData();
          this.$message.success('已成功创建一份该设计的副本');
       })
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([
          {
            name: "全部",
            id: 0,
          },
        ]);
      }
      if (node.level > 1) {
        let dir_id = node.data.id;
        Space.directory(
          {
            team_id: this.moreInfo.team_id,
            dir_id,
          },
          "GET"
        ).then((res) => {
          resolve(res.data);
        });
      }
      if (node.level === 1) {
        // 二级节点
        Space.directory(
          {
            team_id: this.moreInfo.team_id,
            dir_id: 0,
          },
          "GET"
        ).then((res) => {
          resolve(res.data);
        });
      }
    },
    moveTreeClick(data) {
      // 弹出框打开
      this.folderTree = data;
    },
    moveSubmit() {
      Space.move({
        team_id: this.loginInfo.current_team_id,
        team_user_design_id: this.moreInfo.id,
        dir_id: this.folderTree.id,
      }).then((res) => {
        if (res.status === 1) {
          this.$message.success(res.message);
          this.moveDialogStatus = false;
          this.getData();
        }
      });
    },
    closeMove() {
      this.moveDialogStatus = false;
    },
    removeDialogOpen() {
      let res = this.expireHandle();
      if(res){
        this.removeDialogStatus = true;
      }
    },
    removeFolder() {
      if (Object.keys(this.moreInfo).includes("cover_url")) {
        Space.delete({
          team_user_design_id: this.moreInfo.id,
          team_id: this.moreInfo.team_id,
        }).then((res) => {
          this.removeDialogStatus = false;
          this.moreInfo = null;
          if (res.status === 1) {
            this.$message.success("删除成功");
            this.removeDialogStatus = false;
            this.getData();
          }
        });
      } else {
        // 修改文件夹信息
        Space.deleteDir(
          {
            team_id: this.moreInfo.team_id,
            dir_id: this.moreInfo.id,
          }
        ).then((res) => {
          this.removeDialogStatus = false;
          this.moreInfo = null;
          if (res.status === 1) {
            this.$message.success("删除成功");

            this.getData();
          }
        });
      }
    },
    goDetail(item) {
      // 进入文件夹详情
      console.log(item)
      if (item === 0) {
        this.dir_id = item;
        this.breadList = [];
        this.getData({
          dir_id: 0,
          page_size: 25,
          page: 1,
        });
      } else {
        let index = null;
        for (let i = 0; i < this.breadList.length; i++) {
          if (this.breadList[i].id === item.id) {
            index = i;
          }
        }
        if (index === null) {
          this.breadList.push(item);
        } else {
          this.breadList.splice(index + 1, this.breadList.length);
        }
        this.dir_id = item.id;
        this.getData({
          dir_id: item.id,
          page_size: 25,
          page: 1,
        });
      }
    },
    uploadPsdOpen() {
      const href = `/enterprise-design-v1?f=qiye&mode=4&ckey=custom&nature=user&dirid=${this.dir_id}`
      window.location.href = href
      // let res = this.expireHandle();
      // if (res) {
      //   this.uploadPsdStatus = true;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.template {
  padding: 0 24px;

  // .bread {
  //   cursor: pointer;
  //   font-size: 13px;
  //   font-weight: 400;
  //   height: 52px;
  //   line-height: 52px;
  //   color: #2d2d32;

  //   ul {
  //     display: flex;

  //     .purple-active {
  //       color: #7966fe;

  //       .iconfont {
  //         color: #7966fe;
  //       }
  //     }
  //   }
  // }
}

.folder-ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  li {
    margin-right: 20px;
    @include wh(150px, 150px);
    border-radius: 8px;
    position: relative;
    margin-bottom: 30px;
    cursor: pointer;

    &:hover {
      background: $hoverColor;

      .el-icon-more {
        display: block;
      }

      // .folder-len {
      //   color: #7966fe;
      // }
    }

    img {
      @include wh(96px, 76px);
      display: block;
      margin: 18px auto 6px;
    }

    p {
      &.folder-name {
        font-size: 14px;
        color: #3c3c43;
        line-height: 20px;
        height: 20px;
        overflow: hidden;
        text-align: center;
      }

      &.folder-len {
        font-size: 12px;
        color: #646469;
        line-height: 16px;
        height: 16px;
        margin-top: 6px;
        text-align: center;
      }
    }
  }
}

.more-box {
  width: 160px;
  background: #fff;
  box-shadow: 0px 0px 20px 0 rgba(175, 175, 175, 0.44);
  border-radius: 8px;
  text-align: center;
  padding: 0 5px;
  border: none;
  position: absolute;
  top: 150px;
  left: 120px;
  z-index: 99;
  margin-bottom: 10px;

  p {
    line-height: 44px;
    height: 45px;
    font-size: 14px;
    font-weight: 400;
    color: #424244;
    border-bottom: 1px solid #e7e7e7;
    cursor: pointer;

    &:hover {
      color: $activeColor;
    }
  }
}

.el-icon-more {
  @include wh(16px, 16px);
  background: rgba(0, 0, 0, 0.6);
  border-radius: 2px;
  font-size: 10px;
  color: #fff;
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 99;
  text-align: center;
  line-height: 16px;
  cursor: pointer;
  display: none;
}

.image-ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  li {
    @include wh(150px, 178px);
    margin: 0 20px 20px 0;
    cursor: pointer;

    &:hover {
      .image-d {
        background-color: $hoverColor;
      }

      .el-icon-more {
        display: block;
      }
    }

    .image-box {
      width: 150px;
      height: 150px;
      border-radius: 8px;
      margin-bottom: 8px;
      position: relative;

      .image-d {
        @include wh(100%, 100%);
        border-radius: 8px;
      }

      ::v-deep( .el-image) {
        @include wh(150px, 150px);
      }

      ::v-deep( .el-image__inner) {
        object-fit: scale-down;
        @include wh(150px, 150px);
      }
    }

    > p {
      @include wh(150px, 20px);
      font-size: 14px;
      color: #3c3c43;
      line-height: 20px;
      text-align: center;
    }
  }
}

.move-main {
  @include wh(440px, 302px);
  border: 1px solid #e1e1e1;
  margin: 0 auto;
  padding: 16px 8px 11px 0;
  overflow: hidden;
  border-radius: 8px;
}
</style>
